import { SVGProps } from "react";

export default function ArrowSuccessIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M13.2972 11.8123C13.2188 11.7339 13.1693 11.6266 13.1693 11.5029L13.1693 6.93263L8.59904 6.93263C8.3598 6.93263 8.16181 6.73464 8.16181 6.4954C8.16181 6.25617 8.3598 6.05818 8.59904 6.05818L13.6065 6.05818C13.8458 6.05818 14.0438 6.25617 14.0438 6.4954L14.0438 11.5029C14.0438 11.7421 13.8458 11.9401 13.6065 11.9401C13.4869 11.9443 13.3755 11.8906 13.2972 11.8123Z"
        fill="#00B207"
      />
      <path
        d="M6.285 13.8154C6.11588 13.6463 6.11588 13.3658 6.285 13.1967L13.227 6.25467C13.3961 6.08556 13.6766 6.08556 13.8457 6.25467C14.0149 6.42379 14.0149 6.70427 13.8457 6.87339L6.90372 13.8154C6.7346 13.9845 6.45411 13.9845 6.285 13.8154Z"
        fill="#00B207"
      />
    </svg>
  );
}
